define('common/alertMessage',[
],
    function () {

        const alertSelector = "#alertMessage";
        const allButtonsSelector = alertSelector + " .modal-footer button";
        const buttonSelector = {
            ok: allButtonsSelector + ".ok",
            yes: allButtonsSelector + ".yes",
            no: allButtonsSelector + ".no"
        };

        function show(messageText, okCallback) {
            setIcon();
            setButtons("ok", okCallback);
            displayAlert(messageText);
        }

        function info(messageText, okCallback) {
            setIcon("info");
            setButtons("ok", okCallback);
            displayAlert(messageText);
        }

        function warning(messageText, okCallback) {
            setIcon("warning");
            setButtons("ok", okCallback);
            displayAlert(messageText);
        }
        
        function error(messageText, okCallback, displayDefaultMessage) {
            setIcon("error");
            setButtons("ok", okCallback);            
            if (typeof messageText === 'undefined' || messageText === null) messageText = "";
            if (typeof displayDefaultMessage === 'undefined') displayDefaultMessage = true;
            if (displayDefaultMessage || messageText === "") {
                messageText = CP.Messages["General/Default Error Message"] + messageText;
            }
            displayAlert(messageText);
        }

        function yesNoQuestion(messageText, yesCallback, noCallback) {
            setIcon("question");
            setButtons("yes-no", yesCallback, noCallback);
            displayAlert(messageText);
        }

        function setIcon(iconName) {
            $(alertSelector + " .icons").addClass("d-none");
            $(alertSelector + " i").addClass("d-none");
            if (iconName) {
                $(alertSelector + " .icons").removeClass("d-none");
                $(alertSelector + " i." + iconName).removeClass("d-none");
            }
        }

        function setButtons(buttons, callback1, callback2) {
            $(allButtonsSelector).addClass("d-none");
            $(buttonSelector.ok).off("click");
            $(buttonSelector.yes).off("click");
            $(buttonSelector.no).off("click");
            if (buttons === "yes-no") {
                $(buttonSelector.yes).removeClass("d-none");
                $(buttonSelector.no).removeClass("d-none");
                $(buttonSelector.yes).on("click", function () { hideAndCallback(callback1); });
                $(buttonSelector.no).on("click", function () { hideAndCallback(callback2); });
            }
            else {
                $(buttonSelector.ok).removeClass("d-none");
                $(buttonSelector.ok).on("click", function () { hideAndCallback(callback1); });
            }
        }

        var alertModal;

        function displayAlert(messageText) {
            $(alertSelector + " .alert-text").empty().html(messageText);
            if (!alertModal) {
                // initializing alertModal
                var alertElement = document.querySelector(alertSelector);
                if (alertElement) {
                    alertModal = bootstrap.Modal.getOrCreateInstance(alertElement, { backdrop: "static", keyboard: false });
                    if (!alertModal) console.log("Alert modal not initialized for " + alertSelector);
                }
                else console.log("There's no alert modal with selector " + alertSelector);
            }
            if (alertModal) alertModal.show();
        }

        function hideAndCallback(callback) {
            if (callback) $(alertSelector).one("hidden.bs.modal", callback);
            if (alertModal) alertModal.hide();
        }

        return {
            show: show,
            info: info,
            warning: warning,
            error: error,
            yesNoQuestion: yesNoQuestion
        };
    });

